
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 2.02002C6.48999 2.02002 2.01999 6.49002 2.01999 12C2.01999 17.51 6.48999 21.98 12 21.98C17.51 21.98 21.98 17.51 21.98 12C21.98 6.49002 17.51 2.02002 12 2.02002ZM11.48 17.88V13.74H8.81999C8.44999 13.74 8.19999 13.34 8.37999 13.01L12.06 5.84002C12.29 5.37002 13 5.54002 13 6.07002V10.26H15.54C15.91 10.26 16.15 10.65 15.99 10.98L12.43 18.1C12.19 18.58 11.48 18.41 11.48 17.88Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-offline-bolt`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconOfflineBolt

    ```js
    <b-new-b-icon-offline-bolt />
    ```
</docs>


